<template>
  <div v-if="loaded && !bannerClosed">
    <template v-if="!isEditing">
      <div v-if="bannerClosed === false">
        <div v-if="fields" class="c-banner" :class="{ hide: isClicked }">
          <sc-rich-text
            v-if="fields && fields.content"
            :field="fields.content"
            class="c-banner__content"
          />
          <button
            v-if="
              fields &&
              fields.content &&
              fields.content.value &&
              fields.content.value.length > 0 &&
              bannerCloseEnabled
            "
            class="c-banner__close"
            aria-label="Close Banner"
            @click="closeBanner"
          ></button>
        </div>
      </div>
    </template>
    <template v-else>
      <div v-if="fields" class="c-banner">
        <sc-rich-text
          v-if="fields && fields.content"
          :field="fields.content"
          class="c-banner__content"
        />
        <button class="c-banner__close"></button>
      </div>
    </template>
  </div>
</template>

<script>
import { defineComponent, nextTick } from 'vue';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import { useCookies } from 'vue3-cookies';

export default defineComponent({
  name: 'CIS-Banner',
  components: {
    ScRichText: RichText
  },
  props: {
    fields: {
      type: Object
    }
  },
  data: function () {
    return {
      isClicked: false,
      bannerCloseEnabled: false,
      bannerClosed: false,
      loaded: false
    };
  },
  setup() {
    const { cookies } = useCookies();
    return { cookies };
  },
  mounted() {
    const bannerCookie = this.cookies.get('banner');
    this.bannerClosed = bannerCookie === 'closed';

    this.loaded = true;

    if (!this.bannerClosed) {
      nextTick(() => {
        const banner = document.querySelector('.c-site__banner');
        const header = document.querySelector('.c-site__header');
        if (banner && header) {
          header.style = `padding-top: ${banner?.offsetHeight}px;`;
        }
      });

      if (window) {
        window.addEventListener('resize', this.handleResize);
      }

      const waitForCookiebot = setInterval(() => {
        if (typeof Cookiebot === 'object' && Cookiebot.consent?.preferences) {
          clearInterval(waitForCookiebot);
          this.bannerCloseEnabled = true;
        }
      }, 100);
    }
  },
  computed: {
    isEditing() {
      // this.$jss is defined on the Vue instance by the SitecoreJssPlugin and provides
      // reactive access to the `sitecoreContext` provided in layout service data.
      return this.$jss.sitecoreContext().pageEditing;
    }
  },
  methods: {
    handleResize() {
      // use Vue ref to get banner
      const banner = document.querySelector('.c-site__banner');
      const header = document.querySelector('.c-site__header');
      if (header && banner && Number.parseInt(header.style.paddingTop) !== banner.offsetHeight) {
        header.style = `padding-top: ${banner?.offsetHeight}px;`;
      }
    },
    closeBanner() {
      if (Cookiebot?.consent?.preferences) {
        this.cookies.set('banner', 'closed');
      }

      this.isClicked = true;

      const banner = document.querySelector('.c-site__banner');
      if (banner) {
        banner.remove();

        const header = document.querySelector('.c-site__header');
        if (header) {
          header.style = 'padding-top: revert';
        }

        // Hardened Image List Page Element
        const columnHeader = document.querySelector('.c-hardened-images-list .column-headers');
        if (columnHeader) {
          columnHeader.style = '';
        }

        // Cybersecurity Tools
        const columnHeaderCyber = document.querySelectorAll(
          '.c-cybersecurity-tools .column-headers th'
        );
        if (columnHeaderCyber) {
          columnHeaderCyber.forEach((th) => (th.style = ''));
        }
      }
    }
  }
});
</script>
<style lang="scss" scoped>
.c-banner {
  position: relative;
  max-width: $main-max-width;
  margin: 0 auto;

  &__content {
    @include font-styles('Arial', 1.4rem, 400, normal, 1.8rem, 0, $black);
    padding: 1.5rem 5rem 1.5rem 2rem;

    &:deep() {
      a {
        @include font-styles('Arial', 1.4rem, 400, normal, 1.8rem, 0, inherit);

        &:hover {
          text-decoration: underline;
        }
      }

      p {
        @include font-styles('Arial', 1.4rem, 400, normal, 1.8rem, 0, inherit);
      }

      span {
        @include font-styles('Arial', 1.4rem, 400, normal, 1.8rem, 0, inherit);
      }
    }
  }

  &__close {
    position: absolute;
    top: 50%;
    transform: translateY(-55%);
    right: 1.5rem;
    @include font-styles('Arial', 2.4rem, 300, normal, 2.4rem, 0, $black);
    background: transparent;
    border: 0;
    padding: 0;
    background: url(~@/assets/images/icon-close-white.svg) no-repeat;
    background-size: cover;
    width: 1.8rem;
    height: 1.8rem;
    margin-right: 0.5rem;
    filter: invert(1);
  }

  &.hide {
    display: none;
  }
}
</style>
